import { memo } from 'react';
import { Grid, Typography } from 'components/ui';
import { IndexListItemHeader } from 'components/styles_components/list';
import { FormattedMessage } from 'react-intl';
import useMobile from 'hooks/use_mobile';

const ListHeader = ({ visible }) => {
  const isMobile = useMobile();

  if (!visible || isMobile) {
    return null;
  }

  return (
    <IndexListItemHeader>
      <Grid container justifyContent="center" alignItems="center">
        <Grid size={{ xs: 2.4 }} textAlign="left">
          <Typography variant="subtitle2">
            <FormattedMessage id="order.plan" />
          </Typography>
        </Grid>
        <Grid size={{ xs: 2.4 }} textAlign="center">
          <Typography variant="subtitle2">
            <FormattedMessage id="order.orderId" />
          </Typography>
        </Grid>
        <Grid size={{ xs: 2.4 }} textAlign="center">
          <Typography variant="subtitle2">
            <FormattedMessage id="order.amount" />
          </Typography>
        </Grid>
        <Grid size={{ xs: 2.4 }} textAlign="center">
          <Typography variant="subtitle2">
            <FormattedMessage id="order.status" />
          </Typography>
        </Grid>
        <Grid size={{ xs: 2.4 }} textAlign="center">
          <Typography variant="subtitle2">
            <FormattedMessage id="order.createdAt" />
          </Typography>
        </Grid>
      </Grid>
    </IndexListItemHeader>
  );
};

export default memo(ListHeader);
